import BaseService from './baseService';

class Laporan extends BaseService {
  async laporan(payload) {
    this.endPoint = '/items/itemSearch';
    return await this.post(payload);
  }
  async printLaporan(payload) {
    this.endPoint = '/items/print-laporan';
    return await this.post(payload);
  }
  
}

export default new Laporan();